import XLSX from 'xlsx'
import store from './store'

window.XLSX = XLSX

export const mapCp = (mapY) => {
  let newMap = {}
  for (let key in mapY) {
    newMap[key] = mapY[key]
  }
  return newMap
}

export const cmpDate = (dateStr) => {
  return new Date(dateStr.length === 10 ? dateStr : (dateStr.substr(0, 10) + 'T' + dateStr.substr(11, 8)))
}

export const listToChartData = (dataList, xKey, legendKey, chartDataKey) => {
  let xDatas = []
  let legends = []
  let chartDatas = []
  let dealData = {}
  dataList.forEach((item) => {
    if (!dealData[item[xKey]]) {
      xDatas.push(item[xKey])
      dealData[item[xKey]] = {}
    }
    if (legends.indexOf(item[legendKey]) === -1) {
      legends.push(item[legendKey])
    }
    dealData[item[xKey]][item[legendKey]] = item[chartDataKey]
  })
  legends.forEach((item) => {
    let newData = []
    xDatas.forEach((xItem) => {
      newData.push(dealData[xItem][item])
    })
    chartDatas.push(newData)
  })
  return {xDatas, legends, chartDatas, dealData}
}

export const listToTableData = (dataList, mergeKeyList) => {
  if (mergeKeyList.length === 0) {
    return dataList
  }
  let mergeKey = mergeKeyList[0]
  let reList = []
  let dataMap = {}
  dataList.forEach((itemData) => {
    if (!dataMap[itemData[mergeKey]]) {
      dataMap[itemData[mergeKey]] = []
    }
    dataMap[itemData[mergeKey]].push(itemData)
  })
  for (let mergeData in dataMap) {
    dataMap[mergeData] = listToTableData(dataMap[mergeData], mergeKeyList.slice(1))
  }
  for (let mergeData in dataMap) {
    dataMap[mergeData].forEach((item, index) => {
      let newDataMap = mapCp(item)
      newDataMap[mergeKey] = {
        'label': item[mergeKey],
        'rowspan': index === 0 ? dataMap[mergeData].length : 0
      }
      reList.push(newDataMap)
    })
  }
  return reList
}

export const strToMap = (str) => {
  let mapData = {}
  let listData = str.split(',')
  listData.forEach(function (item) {
    let listData1 = item.split('=')
    mapData[listData1[0]] = listData1[1]
  })
  return mapData
}

export const concatList = (list1, list2) => {
  let newData = []
  list1.forEach((item) => {
    newData.push(item)
  })
  list2.forEach((item) => {
    newData.push(item)
  })
  return newData
}

export const clSortDatas = function (datas, funSort) {
  if (datas.length < 2) {
    return datas
  }
  for (let indexA in datas) {
    for (let indexB in datas) {
      let nIndexB = Number(indexB)
      if (nIndexB < (datas.length - 1 - indexA) && funSort(datas[nIndexB], datas[nIndexB + 1])) {
        [datas[nIndexB], datas[nIndexB + 1]] = [datas[nIndexB + 1], datas[nIndexB]]
      }
    }
  }
  return datas
}

export const printDom = (domId) => {
  let pDom = document.getElementById(domId)
  let win = window.open('')
  win.document.write(pDom.outerHTML)
  win.print()
}

export const outPutExcelFile = (datas, fileName) => {
  let workbook = new window.Excel.Workbook()
  datas.forEach(function (item) {
    let worksheet1 = new window.Excel.Worksheet()
    worksheet1.addAllData(item.data)
    worksheet1.setName(item.sheetName)
    workbook.add(worksheet1)
  })
  workbook.setName(fileName)
  workbook.download()
}

export const clSort = (data, key) => {
  let dataType = []
  let newData = []
  data.forEach(function (item) {
    if (dataType.indexOf(item[key]) === -1) {
      dataType.push(item[key])
    }
  })
  dataType.forEach(function (item) {
    data.forEach(function (item2) {
      if (item2[key] === item) {
        newData.push([...item2])
      }
    })
  })
  return newData
}

export const checkFile = (file, type) => {
}

export const checkData = (data) => {
  return Number(data['期初库存']) + Number(data['入库升数']) - Number(data['出库升数']) - Number(data['期末库存']) - Number(data['损溢'])
}

export const checkRkData = (data, datas) => {
  let jhsh = 0
  datas.forEach((item) => {
    if (item['油品名称'] === data['油品名称']) {
      jhsh = jhsh + item['配送计划'] - item['入库升数']
    }
  })
  return (jhsh > -2000) && (jhsh < 2000)
}

export const checkAllData = (data, datas) => {
  if (store.getters.oilArea === 'dl') {
    return checkData(data) === 0
  } else {
    return checkData(data) === 0 && checkRkData(data, datas)
  }
}

export const testList1ContainList2 = ({list1, list2, list2Key}) => {
  let contain = true
  list2.forEach(function (item) {
    if (list1.indexOf(list2Key ? item[list2Key] : item) === -1) {
      contain = false
    }
  })
  return contain
}

const dealSheetDataToMap = (sheetDatas, needDataKeys) => {
  let newDataList = []
  sheetDatas.forEach(function (itemMap) {
    let newData = {}
    needDataKeys.forEach(function (itemKey) {
      let value = itemKey.key ? itemMap[itemKey.key] : itemMap[itemKey]
      newData[itemKey] = itemKey.delData ? itemKey.formatData(value) : value
    })
    newDataList.push(newData)
  })
  return newDataList
}

const dealSheetDataToList = (sheetDatas) => {
  let newDataList = []
  sheetDatas.split('\n').forEach(function (itemStr) {
    newDataList.push(itemStr.split(','))
  })
  return newDataList
}

export const readExcelFileData = ({file, sheets, type, allsheets}) => {
  return new Promise(function (resolve, reject) {
    let fileReader = new FileReader()
    fileReader.onload = function (e) {
      try {
        let dataMap = {}
        let data = e.target.result
        let wb = XLSX.read(data, {
          type: 'binary'
        })
        // 获取所有sheet数据
        if (allsheets) {
          wb.SheetNames.forEach(function (sheetItem) {
            let delFun = type === 'row_object_array' ? XLSX.utils.sheet_to_row_object_array : XLSX.utils.sheet_to_csv
            let sheetDatas = delFun(wb.Sheets[sheetItem])
            window.cldata = sheetDatas
            dataMap[sheetItem] = type === 'row_object_array' ? dealSheetDataToMap(sheetDatas, sheets[0].needDataKeys) : dealSheetDataToList(sheetDatas)
          })
          resolve(dataMap)
        } else if (testList1ContainList2({list1: wb.SheetNames, list2: sheets, list2Key: 'name'})) {
          sheets.forEach(function (item) {
            let sheetDatas = XLSX.utils.sheet_to_row_object_array(wb.Sheets[item.name])
            dataMap[item.key] = dealSheetDataToMap(sheetDatas, item.needDataKeys)
          })
          resolve(dataMap)
        } else {
          reject(new Error('导入数据格式不规范！'))
        }
      } catch (error) {
        reject(error)
      }
    }
    fileReader.readAsBinaryString(file)
  })
}

export const dateOperating = {
  // 当前时间加减几天days, hours
  computeDay: function ({format = 'number', days = 0, date} = {format: 'number', days: 0}) {
    let nowDate = date || new Date()
    if (days && days !== 0) {
      nowDate.setDate(nowDate.getDate() + days)
    }
    return this.formatDate({
      date: nowDate.getTime(),
      format: format
    })
  },
  formatDate: function ({date = null, format = 'number', days = 0} = {date: null, format: 'number', days: 0}) {
    date = date ? new Date(date) : new Date()
    let month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : String(0) + (date.getMonth() + 1)
    let day = date.getDate() > 9 ? date.getDate() : String(0) + date.getDate()
    if (format === 'yy-mm-dd') {
      return date.getFullYear() + '-' + month + '-' + day
    } else if (format === 'yy/mm/dd') {
      return date.getFullYear() + '/' + month + '/' + day
    } else if (format === 'yy年mm月dd日') {
      return date.getFullYear() + '年' + month + '月' + day + '日'
    } else if (format === 'yy.mm.dd') {
      return date.getFullYear() + '.' + month + '.' + day
    } else if (format === 'yy-mm-dd hh:mm') {
      return date.getFullYear() + '-' + month + '-' + day + ' ' + date.getHours() + ':' + date.getMinutes()
    } else {
      return date.getTime()
    }
  },
  getMonthDays: function (year, month) {
    if (!year || !month) {
      return 0
    }
    year = Number(year)
    month = Number(month)
    let date1 = new Date(year + '-' + month + '-01 00:00:00')
    let date2Year = month === 12 ? year + 1 : year
    let date2Month = month === 12 ? 1 : month + 1
    let date2 = new Date(date2Year + '-' + date2Month + '-01 00:00:00')
    return (date2.getTime() - date1.getTime()) / 1000 / 60 / 60 / 24
  },
  minusDate: function (d1 = new Date(), d2 = new Date()) {
    return d1.getTime() - d2.getTime()
  },
  intervalDays: function (dateStr) {
    let date = new Date(dateStr).getDate()
    let date2 = new Date().getDate()
    return date - date2
  }
}



// WEBPACK FOOTER //
// ./src/cllib.js